import React, { useState } from "react";
import SingleUrlValidator from "./SingleUrlValidator";
import MultipleUrlValidator from "./MultipleUrlValidator";
import * as XLSX from "xlsx";
import imageClient from "lib/image-client";
import useLoad from "hook/useLoad";

export default function ImageValidator({
  showEncryptedModal,
  handleClose,
  btnEncryptedShow,
  handleMultipleUrlEncrypted,
  handleSingleUrlEncrypted,
}) {
  const [isLoad, funcLoader] = useLoad()
  const [results, setResults] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMultipleValidaotr, setErrorMultipleValidaotr] = useState("");

  //==========================single validator ============================//

  const [imageValidatorUrl, setImageValidatorUrl] = useState("");
  const [errorSingleValidaotr, setErrorSingleValidaotr] = useState("");
  const [imageValidationData, setImageValidationData] = useState({ url: "" });

  //=======================================single Encrytpted URL logic =======================================================//

  const handleSingleSubmit = async () => {
    setErrorSingleValidaotr("");
    funcLoader(async () => {
      const { pathFile, message, error } = await imageClient.handleSingleSubmit(imageValidatorUrl)
      if (error) {
        console.error("Error fetching validation data:", error);
        setErrorSingleValidaotr("An error occurred while validating the URL."); // Set error message
        return
      }
      setImageValidationData({ pathFile, message });
    })

  };

  const handleChangeUrl = (e) => setImageValidatorUrl(e.target.value);
  

  const handleResetPath = () => {
    setImageValidatorUrl("");
    setImageValidationData({
      pathFile: "",
      exist: null,
      imageUrl: "",
      message: "",
    });
  };

  //=======================================multiple Encrytpted URL logic =============================================//

  const handleFileChange = (event) => setFile(event.target.files[0]);
  

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    setLoading(true);
    setErrorMultipleValidaotr("");

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

      const urls = json
        .flat()
        .filter((url) => url && typeof url === "string")
        .map((url) => ({ url: url.trim() }));

      const apiUrl = "https://images.kgkdms.com/damImage/pathencryption";

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(urls),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const resultsData = await response.json();

        setResults(resultsData);
      } catch (apiError) {
        errorMultipleValidaotr("Error occurred while calling the API");
        console.error("API Error:", apiError);
      } finally {
        setLoading(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleResetEncryption = () => {
    setFile(null);
    setResults([]);
    setErrorMultipleValidaotr("");
    document.getElementById("formFileSm").value = null;
  };



  return (
    <>
      <div
        className={`modal fade show`}
        style={{
          display: showEncryptedModal ? "block" : "none",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden={!showEncryptedModal}
      >
        <div className="modal-fullscreen" style={{ height: "100%" }}>
          <div className="modal-content" style={{ height: "100%" }}>
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Image Path Encryption
              </h1>
              <div className="d-flex justify-content-end">
                <div
                  className="btn-group mr-2"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={btnEncryptedShow === true}
                    onClick={handleSingleUrlEncrypted}
                  >
                    Single Url Validator
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={btnEncryptedShow === false}
                    onClick={handleMultipleUrlEncrypted}
                  >
                    Multiple Url Validator
                  </button>
                </div>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
            <div className="modal-custom-body">
              {btnEncryptedShow ? (
                <SingleUrlValidator
                  handleReset={handleResetPath}
                  imageValidatorUrl={imageValidatorUrl}
                  handleChangeUrl={handleChangeUrl}
                  loadingImageData={isLoad}
                  imageValidationData={imageValidationData}
                  handleSingleSubmit={handleSingleSubmit}
                  errorSingleValidaotr={errorSingleValidaotr}
                />
              ) : (
                <MultipleUrlValidator
                  results={results}
                  setResults={setResults}
                  handleSubmit={handleSubmit}
                  handleFileChange={handleFileChange}
                  handleResetEncryption={handleResetEncryption}
                  error={errorMultipleValidaotr}
                  loading={loading}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
